module.exports = __webpack_public_path__ + "img/desktop_success_banner.2bc89ea5.png";